export function DynamicPricingFact({
  label,
  value,
  mono,
}: {
  label: string;
  value: string;
  mono?: boolean;
}) {
  return (
    <div className="min-w-0">
      <span className="text-ink-faint block text-[10px] font-semibold uppercase tracking-wide">
        {label}
      </span>
      <strong className={mono ? 'block truncate font-mono text-xs' : 'block text-sm'}>
        {value}
      </strong>
    </div>
  );
}
